module.exports = __webpack_public_path__ + "static/img/banner-introduce.dd598f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/gotoContent/banner-introduce.jpg
// module id = RX5A
// module chunks = 0